import React, { useState } from "react";
import WeekSelector from "../../../components/WeekSelector";
import { useSiteContext } from "../../../SiteContext";
import PaycorManager from "../../../managers/PaycorManager";
import "./PaycorDownload.css";
import PageWrapper from "../../../components/PageWrapper";
import Colors from '../../../styles/Colors.json';

interface PaycorDownloadProps {
  setError: (error: string | null) => void;
}

const PaycorDownload: React.FC<PaycorDownloadProps> = ({ setError }) => {
  const { setLoading, year, startDate, endDate, week, payPeriodID, createPopup, translator } = useSiteContext();

  const handleDownloadClick = async () => {
    try {
      createPopup('Download Initiated', `Getting Paycor v2 Files for week ${week}, ${year}.`)
      setLoading(true);
      
      // Call the new V2 method to download the .zip file directly
      await PaycorManager.downloadPaycorV2File(payPeriodID);
      
      // Show success message
      createPopup("Download Complete", `Paycor V2 file for week ${week}, ${year} has been downloaded successfully.`);
      
    } catch (error) {
      console.error("Error downloading Paycor V2 file:", error);
      createPopup("Download Failed", `Failed to download Paycor V2 file for week ${week}, ${year}. Please try again.`);
      setError("Failed to download Paycor V2 file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper title={translator.translate("paycorDownloadV2")} backgroundColor={Colors.White} weekSelector={true}>
      <div className="downloadable-data">
        <button className="download-btn" onClick={handleDownloadClick}>
        {translator.translate("DownloadPaycorForWeekV2")} {week} / {year}
        </button>
      </div>
    </PageWrapper>
  );
};

export default PaycorDownload;
